/// <amd-module name="Dashboards/DashboardView/src/components/headers/EditModeHeader" />
import * as React from "react";

import * as Resources from "Dashboards/DashboardView/Resources";

import { Button } from "VSSUI/Button";

interface EditModeHeaderProps {
    onDoneEditing: () => void;
}

export class EditModeHeader extends React.PureComponent<EditModeHeaderProps> {
    public render(): JSX.Element {
        return (
            <div className="dashboard-edit-mode-header flex-row flex-noshrink">
                <span>{Resources.EditHeader_Instructions}</span>
                <Button
                    className="done-editing-button"
                    primary
                    text={Resources.EditHeader_DoneEditingButtonText}
                    onClick={this.props.onDoneEditing}
                />
            </div>
        );
    }
}
